import React from 'react'
import Modal from 'react-responsive-modal'
import styles from './styles.module.css'

import Table from '../Table'
import Button from '../Button'

export default function ModalComponent({ data, closeModal, height, selectedItemsTab, setSelectedItemsTab }) {

  const handleSelect = (item) => {
    if (selectedItemsTab?.includes(item)) {
      setSelectedItemsTab(selectedItemsTab.filter(el => el !== item))
    } else {
      setSelectedItemsTab([...selectedItemsTab, item])
    }
  }

  const renderLi = (item, index) => {
    return (
      <tr key={index}>
        <td
          onClick={() => handleSelect(item)}
          style={{ backgroundColor: selectedItemsTab?.find(el => el == item) ? '#3689FF' : '' }}
        >
          {item}
        </td>
      </tr>
    )
  }
  return (
    <>
      <Modal
        open={!!data}
        onClose={closeModal}
        closeOnOverlayClick={true}
        closeOnEsc={true}
        showCloseIcon={true}
        classNames={{
          // overlay: styles.overlay,
          modal: styles.custom
        }}
      >
        <>
          <div className={styles.modalLocal} >
            <Table className={styles.table} >
              <thead>
                {/* <tr>
                  <th>Ученица</th>
                  </tr> */}
              </thead>
              <tbody>
                {data?.map(renderLi)}
              </tbody>
            </Table>
            <br />
            <br />
            <Button onClick={closeModal}>Выбрать</Button>
          </div>
        </>
      </Modal>
    </>

  )
}
